let resumeData = {
    "imagebaseurl":"https://portfolio-inigomunoz.netlify.app/",
    "name": "Íñigo Muñoz Jiménez",
    "role": "Backend Developer & Technical Owner | APIs REST · Integraciones · E-commerce",
    "roleDescription": "Especializado en APIs REST, integraciones empresariales y e-commerce crítico. +130K clientes sincronizados en 5 países.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/imjdev/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/inigo-munoz",
          "className":"fa fa-github"
        },
        {
          "name":"mail",
          "url":"mailto:inigomunozjimenez@gmail.com",
          "className":"fa fa-envelope"
        }
      ],
    "aboutme":"Backend Developer con experiencia en integraciones empresariales, APIs REST y e-commerce B2B/B2C a escala. Actúo como referente técnico en proyectos críticos: arquitectura, estimación, desarrollo y entrega end-to-end con contacto directo al cliente. Stack principal en PHP, con experiencia real en Node.js en producción y evolución activa hacia TypeScript. Abierto a roles de Backend Developer o Technical Owner/Lead en entornos 100% remotos.",
    "education":[
      {
        "UniversityName":"Ironhack",
        "specialization":"Full Stack Web Developer",
        "MonthOfPassing":"Jun",
        "YearOfPassing":"2022",
        "Achievements":"Bootcamp intensivo de desarrollo web full stack (9 semanas). Stack MERN: JavaScript (ES6), MongoDB, Express, Node.js, React. Herramientas: Git, Postman, Stripe, Heroku, Netlify."
      },
      {
        "UniversityName":"FP Grado Superior",
        "specialization":"Desarrollo de Aplicaciones",
        "MonthOfPassing":"Jun",
        "YearOfPassing":"2006",
        "Achievements":"Programación con SQL, Visual Basic y C++."
      }
    ],
    "work":[
        {
          "CompanyName": "Backend Developer & Technical Owner",
          "specialization": "Remoto · Abril 2023 – Actualidad",
          "MonthOfEnter": "Apr",
          "MonthOfLeaving": "Now",
          "YearOfLeaving": "2023",
          "Achievements": `Único desarrollador backend en proyectos críticos de e-commerce e integración empresarial. Responsable de arquitectura, estimación, desarrollo y entrega con contacto directo al cliente.

Dentaid — Technical Owner de integración bidireccional PrestaShop ↔ SAP: +130.000 clientes sincronizados en 10 entornos (B2B/B2C) y 5 países.

WhatsApp Business Agent — Sistema de detección de oportunidades de negocio: Node.js + n8n + PostgreSQL + Docker. Arquitectura en dos capas: backend (lógica) y n8n (orquestación).

TCM Gourmet — API REST completa para app móvil React Native: 20+ endpoints, autenticación JWT, catálogo, carrito y pedidos.

Recoautos — Sistema de contraofertas con workflow de estados, notificaciones y panel de administración. Integración con Connectif.

Cursor AI Governance — Definición e implementación de gobernanza de uso del agente de IA para el equipo: reglas operativas, convenciones de código y estándares por tipo de proyecto.

Único desarrollador certificado en BigCommerce de la empresa, habilitando el partnership oficial con la plataforma.

Stack: PHP · Node.js · TypeScript · MySQL · PostgreSQL · Docker · APIs REST · JWT · PrestaShop · BigCommerce · PHPUnit · Git`
        },
      {
        "CompanyName":"Technical Teaching Assistant",
        "specialization":"Ironhack · Remoto · Sep 2022 – Nov 2022",
        "MonthOfEnter":"Sept",
        "MonthOfLeaving":"Nov",
        "YearOfLeaving":"2022",
        "Achievements":`Mentoría técnica a estudiantes en proyectos full stack con JavaScript, Node.js, React y MongoDB.
Revisión de código, debugging en tiempo real y refuerzo de buenas prácticas en entorno ágil intensivo.`
      },
      {
        "CompanyName":"IT & Backend Developer",
        "specialization":"Universidad de Huelva · Abr 2021 – Mar 2022",
        "MonthOfEnter":"Apr",
        "MonthOfLeaving":"Mar",
        "YearOfLeaving":"2022",
        "Achievements":`Desarrollo y personalización de wiki interna con BookStack para ~13.000 usuarios, reduciendo incidencias en un 50%.
Implementación de funcionalidades en PHP con integraciones a LiveChat e iTopHub.
Soporte en Moodle, Zoom y Microsoft Teams.`
      },
      {
        "CompanyName":"Freelance Web Developer",
        "specialization":"Autónomo · Remoto · May 2017 – Mar 2021",
        "MonthOfEnter":"May",
        "MonthOfLeaving":"Mar",
        "YearOfLeaving":"2021",
        "Achievements":`Diseño, desarrollo e implantación de proyectos web y e-commerce (WordPress, PrestaShop) para clientes del sector cultural y comercio local.
Gestión completa del ciclo de proyecto: análisis, desarrollo, puesta en producción y mantenimiento evolutivo.`
      }
    ],
	"skillsDescription":"Soft Skills",
	"skills":[
	  { "skillname": "Resolución de problemas", "level": 90 },
	  { "skillname": "Comunicación técnica", "level": 85 },
	  { "skillname": "Autonomía", "level": 90 },
	  { "skillname": "Atención al detalle", "level": 90 },
	  { "skillname": "Trabajo en equipo", "level": 85 },
	  { "skillname": "Adaptabilidad", "level": 85 },
	  { "skillname": "Gestión del tiempo", "level": 80 },
	  { "skillname": "Documentación", "level": 85 }
	],
    "portfolio":[
      {
        "name": "Cursor AI Governance — Core",
        "description": "Framework de gobernanza técnica para equipos que usan Cursor AI. Define principios, estructura de stacks y flujo SDD para desarrollo consistente en entornos ecommerce críticos.",
        "imgurl": "https://res.cloudinary.com/djersm2h6/image/upload/v1768307348/counteroffer_nouho4.png",
        "url": "https://github.com/inigo-munoz/cursor-governance-core",
        "giturlf": "https://github.com/inigo-munoz/cursor-governance-core"
      },
      {
        "name": "Cursor AI Governance — PrestaShop 8",
        "description": "Stack de gobernanza para PrestaShop 8 con Cursor AI. Cubre Service Layer, multishop, integraciones SAP, seguridad y flujo SDD completo.",
        "imgurl": "https://res.cloudinary.com/djersm2h6/image/upload/v1751021910/prestaapi_er9ssx.png",
        "url": "https://github.com/inigo-munoz/cursor-governance-prestashop8",
        "giturlf": "https://github.com/inigo-munoz/cursor-governance-prestashop8"
      },
      {
        "name": "CounterOffer API",
        "description": "API REST en Node.js para gestión de contraofertas en ecommerce. Workflow de estados, notificaciones y panel de administración.",
        "imgurl": "https://res.cloudinary.com/djersm2h6/image/upload/v1768307348/counteroffer_nouho4.png",
        "url": "https://counteroffer-api-production.up.railway.app",
        "giturlf": "https://github.com/inigo-munoz/counteroffer-api"
      },
      {
        "name":"Wiki Universidad de Huelva",
        "description":"Wiki con BookStack para ~13.000 usuarios. Reducción del 50% en incidencias de soporte.",
        "imgurl":"https://res.cloudinary.com/djersm2h6/image/upload/v1655982892/imagesportfolio/uhu_mn5ost.png",
        "url": "https://ayudame.uhu.es/docs/",
        "giturlf": ""
      },
      {
        "name":"Vinegar",
        "description":"Aplicación para gimnasios y entrenadores. Proyecto Ironhack (Node.js, MongoDB, Express).",
        "imgurl":"https://res.cloudinary.com/djersm2h6/image/upload/v1655546449/imagesportfolio/vinegar_1_y7kprc.png",
        "url": "https://vinegar-y9kl.onrender.com/",
        "giturlf": "https://github.com/inigo-munoz/vinegar"
      },
      {
        "name":"Miecocaja",
        "description":"Plataforma e-commerce ecológica. Proyecto Ironhack (React, Node.js, MongoDB).",
        "imgurl":"https://res.cloudinary.com/djersm2h6/image/upload/v1655546450/imagesportfolio/miecocaja_1_xz5ub7.png",
        "url": "https://ecocajas.netlify.app/",
        "giturlf": "https://github.com/inigo-munoz/cajas-ecologicas-client"
      },
      {
        "name":"Cerveza Belona",
        "description":"Tienda e-commerce de cerveza artesanal. Desarrollada en PrestaShop.",
        "imgurl":"https://res.cloudinary.com/djersm2h6/image/upload/v1655546450/imagesportfolio/belona_qmgrwi.png",
        "url": "https://cervezabelona.com/",
        "giturlf": ""
      }
    ],
    "testimonials":[
      {
        "description":"Durante el bootcamp de Desarrollo Web, Iñigo se destacó como uno de los mejores estudiantes, continuamente demostrando una gran dedicación e interés por la materia. También demostró grandes habilidades de trabajo en equipo y soporte a sus compañeros. Sin duda cualquier empresa conseguiría un desarrollador con excelentes cualidades técnicas y personales al contratar a Iñigo.",
        "name":"Jorge Luis Berrizbeitia Rivas — Tech Lead, Ironhack"
      }
    ]
  }

export default resumeData
